import type { SVGProps } from "react";

export function IconBlackNavProfessionalServices(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.25 2.25H15.75V5.25H19C20.5188 5.25 21.75 6.48122 21.75 8V11.75H2.25V8C2.25 6.48122 3.48122 5.25 5 5.25H8.25V2.25ZM2.25 13.25V21.75H21.75V13.25H12.75V16.25H11.25V13.25H2.25ZM14.25 3.75V5.25H9.75V3.75H14.25Z"
        fill="#0B0C17"
      />
    </svg>
  );
}
